import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { SurveyStatusV2Service } from "../survey-status-v2.service";
import { Envion35Service } from 'app/main/wizard-n35encuestador/services/envion35.service';
import * as backInter from 'app/auth/auth-data.model';
import { SheduleService } from 'app/main/pagina/productos/certificar/tipo_2/services/shedule.service';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
const moment = require('moment');
const momentTz = require('moment-timezone');
import { DatePipe } from '@angular/common';
import { zonasUTC } from 'app/main/pagina/zonasUtc';

@Component({
  selector: 'contenido',
  templateUrl: './contenido.component.html',
  styleUrls: ['./contenido.component.scss']
})
export class ContenidoComponent implements OnInit {

  comunicacionMenu: any;
  @Input() statusMenu: Observable<any>;
  @Input() productoElegido: Observable<any>;
  @Input() cargaPrevio: Observable<any>;

  @Output() nombreEmpresa: EventEmitter<any> = new EventEmitter();
  @Output() account_id: EventEmitter<any> = new EventEmitter();
  @Output() brokerEmpresa: EventEmitter<any> = new EventEmitter();
  @Output() abreMenu: EventEmitter<any> = new EventEmitter();
  @Output() abreDetalles: EventEmitter<any> = new EventEmitter();
  @Output() mostrarIframe: EventEmitter<boolean> = new EventEmitter();
  @Output() infoDetalleProducto: EventEmitter<any> = new EventEmitter();
  // @Output() consultarEmailLog: EventEmitter<boolean> = new EventEmitter();
  infoEmpresaProducto: Subject<any> = new Subject<any>();
  consultarEmailLog: Subject<any> = new Subject<any>();
  setStatusBoton: Subject<any> = new Subject<any>();
  infoSurveyCheck: Subject<any> = new Subject<any>();

  menuVisible = false;
  detallesVisible = true;
  productoActual: any;
  // fechasProducto = [
  //   { fecha: new Date('1/1/16'), tipo: 'Fecha de lanzamiento' },
  //   { fecha: new Date('1/1/21'), tipo: 'Fecha de cierre' },
  // ];
  datosDetallesProducto: any = {
    producto: 0,
    anio: 2000,
    fechasProducto: [
      { fecha: new Date('1/1/16'), tipo: 'lanzamiento', activa: true },
      { fecha: new Date('1/1/21'), tipo: 'cierre', activa: true },
      { fecha: new Date('1/1/21'), tipo: 'prorroga', activa: false },
    ],
    fechasProrrogas: {
      activas: false,
      ultima: new Date(),
      valorDatePicker: new Date()
    },
    progreso: {
      actual: 0,
      total: 0,
      porcentaje: 0
    },
    progresoNom35: {
      menos50: {
        actual: 0,
        total: 0,
        porcentaje: 0
      },
      mas50: {
        actual: 0,
        total: 0,
        porcentaje: 0
      }
    },
    diasRestantes: 0,
    urlEncuesta: '',
    surveyToken: ''
  };
  infoEmpresa: any;
  idEmpresa: string;
  anioProducto: number;
  encuestaCreada: boolean;
  cargandoStatusEncuesta = true;
  encuestaActiva: boolean;
  statusEncuesta = 0;
  datosSurveyCheck: any;
  tipoProductoNorma=false;

  filtroLanzamiento: any;
  filtroCierreProrroga: any;
  urlNormaMas50: string="";
  urlNormaMenos50: string="";

  //zonas horarias
  zonasUTC = zonasUTC;
  indiceZona: number;
  offsetPipe:any;
  diferenciaUtc: number;
  idiomaActual: string;
  city_name: string;
  tokenConfig: string;
  oportunity_id: string;
  accountId: string;
  fechaLanzamientoEncuesta:any;
  recordatoriosFullInfo: any;
  fechasAvisos: any[];
  mostrarMatRecorda:boolean=false;
  mostrarMatAvisos:boolean=false;
  fechasProrrogasRegis: any;

  datoCargadoNorm:boolean=false;
  fechaGTM:boolean=false;
  ocultarContenidoGoFlow=false;
  constructor(
    private activatedRoute : ActivatedRoute,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service,
    private envioService: Envion35Service,
    private sheduleService: SheduleService,
    private encuestaService: EncuestaService,
    private datePipe: DatePipe,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    });
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    this.datosEmpresa(this.idEmpresa);
    this.comunicacionMenu = this.statusMenu.subscribe( (datos:any) => {
      if(datos != null){
        console.log("statusMenu:",datos);
        this.menuVisible = datos.menu != null ? datos.menu : this.menuVisible;
        this.detallesVisible = datos.detalles != null ? datos.detalles : this.detallesVisible;
        if(datos.fijar != undefined){
          this.detallesVisible = true;
        }
      }
    });

    this.productoElegido.subscribe((datos:any) => {
      if (datos != null) {
        this.infoEmpresaProducto.next({
          reinciarDatos: true,
        });

        console.log("productoEnviado:",datos);
        this.productoActual = datos;
        this.obtieneDatosProducto();
        this.setTipoProducto();
        if (this.productoActual.idProducto!=3) {
          let gmtFecha=moment.parseZone(momentTz(this.productoActual.fechaLanzamiento).tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
          console.log('gmtFecha',gmtFecha);
          this.calculoOffsetPipe(gmtFecha);
        }
      }
    });
    this.cargaPrevio.subscribe((datos:any) => { //Carga de inmediato el spiner si es que regresa del portal conteos
      console.log("llegoDatos:",datos);
      // if (datos != null) {
      //   this.productoActual = {};
      //   this.encuestaCreada = true;
      //   this.cargandoStatusEncuesta = true;
      // }
    });
  }

  calculoOffsetPipe(diff?:any){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = diff!=undefined?diff/60:this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
  }

  datosEmpresa(idEmpresa: string){
    this.surveyServ.getInfoEmpresa(idEmpresa).subscribe((data:any) => {
      console.log("infoEmpresa:",data);
      if(data.message == 'Success'){
        this.infoEmpresa = data.data; // :v
        this.city_name = `TOOLBAR.CITIES.${this.infoEmpresa.institutoEmpresa}`;
        this.nombreEmpresa.emit(this.infoEmpresa.nombreEmpresa);
        this.nombreEmpresa.emit(this.infoEmpresa.nombreEmpresa);
        this.brokerEmpresa.emit(this.infoEmpresa.institutoEmpresa);
        if(this.infoEmpresa.account_id){
          this.account_id.emit(this.infoEmpresa.account_id);
          this.accountId=this.infoEmpresa.account_id;
        }

        localStorage.setItem('instituto_id', this.infoEmpresa.institutoEmpresa.toString());
        localStorage.setItem('nombreEmpresa', this.infoEmpresa.nombreEmpresa);
        this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
        this.calculoOffsetPipe();
      }
    }, error  => {
      console.log("error");
    });
  }

  setDatosDetalle(producto:number, anio:number, fechaInicio:string, fechaFin:string, fechaProrroga:string, prog_actual:number, prog_total:number, progresoNom35?:any){
    // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< FUNCION SET DATOS DETALLES LLAMADA:",{
    //   producto,
    //   anio,
    //   fechaInicio,
    //   fechaFin,
    //   fechaProrroga,
    //   prog_actual,
    //   prog_total,
    //   progresoNom35
    // });
// console.log('fechaFin',fechaFin);

    let hoy = moment();
    let fechaElegida = this.datePipe.transform(new Date(fechaFin),'YYYY/MM/d H:mm:ss',this.offsetPipe);
    console.log('fechaElegida',fechaElegida);
    console.log('hoy',hoy);
    let diffDias: number;
    if(hoy.isAfter(fechaElegida)){
      diffDias = 0;
    } else{
console.log('fechaElegida',moment(fechaElegida));

      diffDias = moment(fechaElegida).diff(hoy,'days',true);
      diffDias=Math.floor(diffDias);
    }
    console.log('diffDias',diffDias);

    let porcentaje = (100 / prog_total) * prog_actual;
    let refDetalle = this.datosDetallesProducto;
    console.log('fechasProrrogasRegis',this.fechasProrrogasRegis);
    console.log("refDet:",JSON.parse(JSON.stringify(refDetalle)));
    console.log('fechaInicio o de Lanzamiento',refDetalle.fechasProducto[0].fecha);
    this.datosDetallesProducto = {
      producto: producto != null ? producto : refDetalle.producto,
      anio: anio != null ? anio : refDetalle.anio,
      fechasProducto: [
        { fecha: fechaInicio != null ? new Date(fechaInicio) : new Date(refDetalle.fechasProducto[0].fecha), tipo: 'lanzamiento', activa: true },
        {
          fecha: fechaFin != null ? new Date(fechaFin) : new Date(refDetalle.fechasProducto[1].fecha),
          tipo: 'cierre',
          activa: fechaProrroga != null || refDetalle.fechasProducto[2].activa == true ? false : true
        },
        {
          fecha: fechaProrroga != null ? new Date(fechaProrroga) : new Date(refDetalle.fechasProducto[2].fecha),
          tipo: 'prorroga',
          activa: fechaProrroga != null || refDetalle.fechasProducto[2].activa == true ? true : false
        },
      ],
      fechasProrrogas: refDetalle.fechasProrrogas,
      progreso: {
        actual: prog_actual != null ? prog_actual : refDetalle.progreso.actual,
        total: prog_total != null ? prog_total : refDetalle.progreso.total,
        porcentaje: prog_actual != null && prog_total != null ? porcentaje : refDetalle.progreso.porcentaje,
      },
      progresoNom35: progresoNom35 != null ? progresoNom35 : refDetalle.progresoNom35,
      diasRestantes: fechaInicio != null && fechaFin != null ? diffDias : refDetalle.diasRestantes,
      urlEncuesta: refDetalle.urlEncuesta,
      surveyToken: refDetalle.surveyToken
    };
    // console.log('localStora',localStorage.getItem('tipoIdProducto'));

    switch (localStorage.getItem('tipoIdProducto')) {
      case '52':
      // console.log("es CGO express no pasa nada ");
      break;
      case '3':
      // console.log("es norma no pasa nada ");
      break;
      case '63':
      // console.log("es norma no pasa nada ");
      if (this.datoCargadoNorm==false) {
        this.getFechaLanzamiento35();
      }else{
        // console.log('Ya cargo la info');

      }
      break;
      default:
      if (this.fechasProrrogasRegis.length>0) {
        console.log('this.fechasProrrogasRegis',this.fechasProrrogasRegis);
        let fechaHoy= moment().format("DD/MM/YYYY");
        let fechaHoyV2= moment();
        let fechaLanzamientoProrroga= moment(this.fechasProrrogasRegis[0].fecha).format("DD/MM/YYYY");
        let fechaLanzamientoProrrogaV2= this.datePipe.transform(new Date(this.fechasProrrogasRegis[0].fecha),'YYYY/MM/d H:mm:ss',this.offsetPipe);
        let fechaLanzamientoEncuesta= moment(this.fechaLanzamientoEncuesta).format("DD/MM/YYYY");
        console.log('this.fechaLanzamientoEncuesta',this.fechaLanzamientoEncuesta);
        if(moment(fechaHoyV2).isAfter(moment(fechaLanzamientoProrrogaV2))){
          this.datosDetallesProducto.diasRestantes=0;
        }else{
          console.log('fechaLanzamientoProrrogaV2',fechaLanzamientoProrrogaV2);
          let dayRest= moment(fechaLanzamientoProrrogaV2).diff(fechaHoyV2,'days',true);
          dayRest=Math.floor(dayRest);
          console.log('dayRest',dayRest);
          this.datosDetallesProducto.diasRestantes= dayRest;
          console.log("Dias restantes",this.datosDetallesProducto.diasRestantes);
        }

      }
      break;
    }

    console.log(">>>>>>>>>>> DATOS DETALLES PRODUCTO:",this.datosDetallesProducto);


    let esperaEncuestaActiva = setInterval( () => {

      if(this.encuestaActiva == true && this.encuestaCreada == true){
        console.log("Entro intervaldo  nsdonasodns}{}{}{}");
        this.infoEmpresaProducto.next({
          detalles: this.datosDetallesProducto
        });
        this.infoDetalleProducto.emit(this.datosDetallesProducto);
        clearInterval(esperaEncuestaActiva);
      }
    }, 0);
  }

  setTipoProducto(){
    let idProducto = this.obtieneTipoProductoCorrecto();
    switch (idProducto) {
      //productos certificar
      case 1: localStorage.setItem('tipoProducto', '1'); break;
      case 20: localStorage.setItem('tipoProducto', 'c1'); break;
      case 40: localStorage.setItem('tipoProducto', 'c3'); break;
      //productos medir
      case 2: localStorage.setItem('tipoProducto', '2'); break;
      case 11: localStorage.setItem('tipoProducto', 'm1'); break;
      case 12: localStorage.setItem('tipoProducto', 'm2'); break;
      case 13: localStorage.setItem('tipoProducto', 'm3'); break;
      case 14: localStorage.setItem('tipoProducto', 'm4'); break;
      case 15: localStorage.setItem('tipoProducto', 'm5'); break;
      case 16: localStorage.setItem('tipoProducto', 'm6'); break;
      case 41: localStorage.setItem('tipoProducto', 'm7'); break;
      //productos pulse check
      case 4: localStorage.setItem('tipoProducto', '3'); break;
      case 42: localStorage.setItem('tipoProducto', 'p1'); break;
      //producto focus area
      case 43: localStorage.setItem('tipoProducto', 'f1'); break;
      //producto nom 35
      case 3: localStorage.setItem('tipoProducto', '5'); this.tipoProductoNorma=true; break;
      //producto cgo express
      case 52: localStorage.setItem('tipoProducto', 'CGOX'); break;
      case 56: localStorage.setItem('tipoProducto', 'am1'); break;
      case 57: localStorage.setItem('tipoProducto', 'td1'); break;
      case 58: localStorage.setItem('tipoProducto', 'pe1'); break;
      case 63: localStorage.setItem('tipoProducto', 'NOM35V3'); break;
      case 70: localStorage.setItem('tipoProducto', 'ResulGoFlow'); break;
      case 75: localStorage.setItem('tipoProducto', 'c6'); break;
    }
  }

  obtieneDatosProducto(){
    let idProducto = this.obtieneTipoProductoCorrecto();
    console.log("obtieneDatos tipoProd:",idProducto);
    console.log("datosProductoActual:",this.productoActual);
    this.anioProducto = this.obtieneFechaProductoCorrecta();
    this.encuestaCreada = false;
    this.cargandoStatusEncuesta = true;
    this.encuestaActiva = undefined;
    //variables de localstorage que ocupa el portal de conteos
    localStorage.setItem('Surveystaus_portal', 'activo');
    localStorage.setItem('idEmpresa_surveysatus', this.idEmpresa);
    localStorage.setItem('companyID', this.idEmpresa);
    localStorage.setItem('productoID', this.obtieneIdProductoCorrecto());
    localStorage.setItem('fechaProducto', this.obtieneFechaProductoCorrecta());
    this.getProrrogasFechasCierre(this.obtieneIdProductoCorrecto());
    // console.log('this.productoActual.idSurvey',this.productoActual.idSurvey);

    if(this.productoActual.idSurvey != undefined || idProducto == 3 || idProducto == 63 || idProducto == 70){
      // this.getBanderaUpdateFechaCierre();
      let esperaEncuestaActiva = setInterval( () => {
        if(this.encuestaActiva == true && this.encuestaCreada == true && idProducto != 70){
          this.obtieneToken();
          clearInterval(esperaEncuestaActiva);
        }
      }, 0);

      switch (idProducto) {
        case 3: //nom35
        // console.log('Aqui esta esta onda');

        this.getFechaLanzamientoNorma(this.productoActual.fechaNorma35);
        this.encuestaActiva = true;
        this.cargandoStatusEncuesta = false;
        if(this.productoActual.idSurveyMas){
          this.encuestaCreada = true;
          this.getPorcentajeN35(this.obtieneIdProductoCorrecto(), 0);
        }
        if(this.productoActual.idSurveyMenos){
          this.encuestaCreada = true;
          this.getPorcentajeN35(this.obtieneIdProductoCorrecto(), 1);
        }

        this.getPilotoDataNorma35(idProducto);

        break;
        case 63: //nom35
        // console.log('Aqui esta esta onda norma v3');

        this.encuestaActiva = true;
        this.cargandoStatusEncuesta = false;
        if(this.productoActual.idSurveyMas){
          this.encuestaCreada = true;
          this.getPorcentajeN35(this.obtieneIdProductoCorrecto(), 0);
        }
        if(this.productoActual.idSurveyMenos){
          this.encuestaCreada = true;
          this.getPorcentajeN35(this.obtieneIdProductoCorrecto(), 1);
        }


        this.getPilotoDataNorma35(idProducto);

        break;
        case 70: //nom35
        // console.log('Aqui esta esta onda norma v3');
        this.encuestaCreada=true;
        this.encuestaActiva=true;
        this.cargandoStatusEncuesta=false;
        this.ocultarContenidoGoFlow=true;
        // // this.infoSurveyCheck.next(respuesta.result);
setTimeout(() => {
  this.urlEncuestas();
}, 2000);

        break;

        default:  //resto de productos
        this.encuestaCreada = true;
        this.urlNormaMas50="";
        this.urlNormaMenos50="";
        this.urlEncuestas();
        break;
      }
    }
  }

  getProrrogasFechasCierre(datos){
    let esperaEncuestaActiva = setInterval( () => {
      if(this.encuestaActiva == true && this.encuestaCreada == true && this.productoActual.idProducto!=70){
        this.surveyServ.getProrrogasFechaCierre(datos).subscribe( (data: any) => {
          console.log("getProrrogasFechaCierre:",data);
          this.fechasProrrogasRegis=data.result;

          if(this.fechasProrrogasRegis.length > 0){
            this.infoEmpresaProducto.next({
              fechasProrrogasRegis: this.fechasProrrogasRegis
            });
            this.setDatosDetalle(null, null, null, null, data.result[0].fecha, null, null);
            this.filtroCierreProrroga = (d: Date | null): boolean => {
              let fechaMinima: any;
              return moment(d || new Date()).format('MM/DD/YYYY') > moment(data.result[0].fecha).format('MM/DD/YYYY')
            };
            this.bloquearEnvias(moment(),data.result[0].fecha);
          }else{
            this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[1].fecha);
          }
        });
        clearInterval(esperaEncuestaActiva);
      }
    }, 0);
  }

  bloquearEnvias(fechaActual:any, fechaCierre:any){
    // console.log("actual:",fechaActual);
    // console.log("cierre:",fechaCierre);
    // console.log("statusEnc:",this.statusEncuesta);

    let idProducto = this.obtieneTipoProductoCorrecto();
    if(this.statusEncuesta != 2){ // Si la encuesta esta cerrada no debe entrar a estas condiciones
      this.setStatusBoton.next({ id: 'primerosColab', status: false});
      this.setStatusBoton.next({ id: 'nuevoColab', status: false});
      this.setStatusBoton.next({ id: 'buscarColab', status: false});
      this.setStatusBoton.next({ id: 'bajarColab', status: false});
      if(moment(fechaCierre).isBefore(moment(fechaActual))){
        // console.log("entro este visne de fecha mayoy a cierre");

        if(idProducto != 52){   //si no es el producto cgo express muestra el boton
          this.setStatusBoton.next({ id: 'enviaReco', status: true});
          this.setStatusBoton.next({ id: 'nuevoColab', status: true});
        }
      }else if (moment(fechaActual).isBefore(moment(this.fechaLanzamientoEncuesta))) {
        // console.log("fecha actual menor a la de  lanzamiento");
        if(idProducto != 52){
          this.setStatusBoton.next({ id: 'enviaReco', status: true});
        }
      }
    }
  }

  obtieneIdProductoCorrecto(){
    let idProductoActual = this.productoActual.idCertificar != undefined ? this.productoActual.idCertificar : undefined;
    if(idProductoActual == undefined){
      idProductoActual = this.productoActual.idMedir != undefined ? this.productoActual.idMedir : undefined;
      if(idProductoActual == undefined){
        idProductoActual = this.productoActual.idPulseCheck != undefined ? this.productoActual.idPulseCheck : undefined;
        if(idProductoActual == undefined){
          idProductoActual = this.productoActual.idNorma35 != undefined ? this.productoActual.idNorma35 : undefined;
          if(idProductoActual == undefined){
            idProductoActual = this.productoActual._id != undefined ? this.productoActual._id : this.productoActual.idProducto;
          }
        }
      }
    }
    return idProductoActual;
  }

  obtieneFechaProductoCorrecta(){
    let anioProducto = this.productoActual.fechaCertificar != undefined ? this.productoActual.fechaCertificar : undefined;
    if(anioProducto == undefined){
      anioProducto = this.productoActual.fechaMedir != undefined ? this.productoActual.fechaMedir : this.productoActual.fechaProducto;
      if(anioProducto == undefined){
        anioProducto = this.productoActual.fechaPulseCheck != undefined ? this.productoActual.fechaPulseCheck : undefined;
        if(anioProducto == undefined){
          anioProducto = this.productoActual.fechaNorma35 != undefined ? this.productoActual.fechaNorma35 : undefined;
          if(anioProducto == undefined){
            anioProducto = this.productoActual.date != undefined ? this.productoActual.date : null;
          }
        }
      }
    }
    return anioProducto;
  }

  obtieneTipoProductoCorrecto(){
    // let idProducto = this.productoActual.idProducto != undefined ? this.productoActual.idProducto : this.productoActual.idProduct;
    let tipoProducto = this.productoActual.tipoProducto != undefined ? this.productoActual.tipoProducto : undefined;
    if(tipoProducto == undefined){
      tipoProducto = this.productoActual.idProducto != undefined ? this.productoActual.idProducto : this.productoActual.idProduct;
    }
    localStorage.setItem('tipoIdProducto',tipoProducto);
    return tipoProducto;
  }

  enviaDatosAcciones(){

    console.log('this.obtieneTipoProductoCorrecto()',this.obtieneTipoProductoCorrecto());

    //envia datos generales del producto a otros componentes
    this.infoEmpresaProducto.next({
      nombreEmpresa: this.infoEmpresa.nombreEmpresa,
      accountId: this.infoEmpresa.accountId,
      codigoProyecto: this.infoEmpresa.codigoProyecto,
      idEmpresa: this.idEmpresa,
      idProducto: this.obtieneIdProductoCorrecto(),
      tipoProducto: this.obtieneTipoProductoCorrecto(),
      datosProducto: this.productoActual,
      urlEncuesta: this.datosDetallesProducto.urlEncuesta,
      indiceZona: this.indiceZona,
      zonasUTC: this.zonasUTC,
      fechaProducto: this.obtieneFechaProductoCorrecta(),
      offsetPipe: this.offsetPipe,
      city_name: this.city_name,
      urlEncuestaNormaMas50:this.urlNormaMas50,
      urlEncuestaNormaMenos50:this.urlNormaMenos50,
      recordatoriosFullInfo:this.recordatoriosFullInfo,
    });
    //activa botones al componente de acciones
    if (this.obtieneTipoProductoCorrecto() != 70) {
      this.setStatusBoton.next({ id: 'updateCounting', status: false});
      this.setStatusBoton.next({ id: 'goPriv', status: false});
      this.setStatusBoton.next({ id: 'goPub', status: false});
    }


    if(this.obtieneTipoProductoCorrecto() != 3){  //si no es la nom35 activa boton de conteos externo
      if (this.obtieneTipoProductoCorrecto() == 70) {
      console.log('entro el producto  ResulGoFlow');
      setTimeout(() => {
        this.setStatusBoton.next({ id: 'regCertifi', status: false});
        this.setStatusBoton.next({ id: 'upNameIcon', status: false});
        this.setStatusBoton.next({ id: 'goCounting', status: true});
        this.setStatusBoton.next({ id: 'genCountingUrl', status: true});
        this.setStatusBoton.next({ id: 'updateCounting', status: true});
        this.setStatusBoton.next({ id: 'verWebComPro', status: false});
        this.setStatusBoton.next({ id: 'auditMan', status: false});
        this.setStatusBoton.next({ id: 'processRes', status: false});
        this.setStatusBoton.next({ id: 'lockRes', status: false});
        this.setStatusBoton.next({ id: 'verRes', status: false});
        // this.setStatusBoton.next({ id: 'surveyCheck', status: false});
        // this.setStatusBoton.next({ id: 'surveyDown', status: false});
        this.setStatusBoton.next({ id: 'masterTable', status: false});

      });

    }else{
      this.setStatusBoton.next({ id: 'goCounting', status: false});
      this.setStatusBoton.next({ id: 'genCountingUrl', status: false});
      this.setStatusBoton.next({ id: 'goCounting_more50', status: false, visible: false});
      this.setStatusBoton.next({ id: 'goCounting_less50', status: false, visible: false});
      this.setStatusBoton.next({ id: 'goSurveyMas50', status: false, visible: false});
      this.setStatusBoton.next({ id: 'goSurveyMenos50', status: false, visible: false});
    }
    } else{

  if(this.productoActual.idSurveyMas){
    this.setStatusBoton.next({ id: 'goCounting_more50', status: false, visible: true});
    this.setStatusBoton.next({ id: 'goSurveyMas50', status: false, visible: true});
  }
  if(this.productoActual.idSurveyMenos){
    this.setStatusBoton.next({ id: 'goCounting_less50', status: false, visible: true});
    this.setStatusBoton.next({ id: 'goSurveyMenos50', status: false, visible: true});
  }
  this.setStatusBoton.next({ id: 'surveyCheck', status: false});
  this.setStatusBoton.next({ id: 'surveyDown', status: false});
  this.setStatusBoton.next({ id: 'masterTable', status: false});
  this.setStatusBoton.next({ id: 'goSurvey', status: true, visible: false});
  this.setStatusBoton.next({ id: 'goCounting', status: true, visible: false});
  this.setStatusBoton.next({ id: 'genCountingUrl', status: true, visible: false});
    }
  }

  enviaDatosAccionesNorV3(){
    //envia datos generales del producto a otros componentes
    this.infoEmpresaProducto.next({
      nombreEmpresa: this.infoEmpresa.nombreEmpresa,
      accountId: this.infoEmpresa.accountId,
      codigoProyecto: this.infoEmpresa.codigoProyecto,
      idEmpresa: this.idEmpresa,
      idProducto: this.obtieneIdProductoCorrecto(),
      tipoProducto: this.obtieneTipoProductoCorrecto(),
      datosProducto: this.productoActual,
      urlEncuesta: this.datosDetallesProducto.urlEncuesta,
      indiceZona: this.indiceZona,
      zonasUTC: this.zonasUTC,
      fechaProducto: this.obtieneFechaProductoCorrecta(),
      offsetPipe: this.offsetPipe,
      city_name: this.city_name,
      urlEncuestaNormaMas50:this.urlNormaMas50,
      urlEncuestaNormaMenos50:this.urlNormaMenos50,
      recordatoriosFullInfo:this.recordatoriosFullInfo,
    });
    //activa botones al componente de acciones
    this.setStatusBoton.next({ id: 'updateCounting', status: false});
    this.setStatusBoton.next({ id: 'goPriv', status: false});
    this.setStatusBoton.next({ id: 'goPub', status: false});
    if(this.obtieneTipoProductoCorrecto() != 63){  //si no es la nom35 activa boton de conteos externo
      this.setStatusBoton.next({ id: 'goCounting', status: false});
      this.setStatusBoton.next({ id: 'genCountingUrl', status: false});
      this.setStatusBoton.next({ id: 'goCounting_more50', status: false, visible: false});
      this.setStatusBoton.next({ id: 'goCounting_less50', status: false, visible: false});
      this.setStatusBoton.next({ id: 'goSurveyMas50', status: false, visible: false});
      this.setStatusBoton.next({ id: 'goSurveyMenos50', status: false, visible: false});
    } else{
      if(this.productoActual.idSurveyMas){
        this.setStatusBoton.next({ id: 'goCounting_more50', status: false, visible: true});
        this.setStatusBoton.next({ id: 'goSurveyMas50', status: false, visible: true});
      }
      if(this.productoActual.idSurveyMenos){
        this.setStatusBoton.next({ id: 'goCounting_less50', status: false, visible: true});
        this.setStatusBoton.next({ id: 'goSurveyMenos50', status: false, visible: true});
      }
      this.setStatusBoton.next({ id: 'surveyCheck', status: false});
      this.setStatusBoton.next({ id: 'surveyDown', status: false});
      this.setStatusBoton.next({ id: 'masterTable', status: false});
      this.setStatusBoton.next({ id: 'goSurvey', status: true, visible: false});
      this.setStatusBoton.next({ id: 'goCounting', status: true, visible: false});
      this.setStatusBoton.next({ id: 'genCountingUrl', status: true, visible: false});
    }
  }

  // getBanderaUpdateFechaCierre(){
  //   let idProductoActual = this.obtieneIdProductoCorrecto();
  //   this.surveyServ.getStatusBanderaProrroga(this.idEmpresa,idProductoActual).subscribe((respuesta:any) => {
  //     console.log("getStatusBanderaProrroga:",respuesta);
  //     // this.permisoProrroga=respuesta.activarProrroga;
  //   });
  // }

  obtieneToken(){
    console.log("+++++++++++++++++++++++++++++++++++++__",this.productoActual.idProducto);
    if(this.productoActual.idProducto == 3 || this.productoActual.idProducto == 63){  //si es producto norma no hace nada
      console.log("no debe de hacer nada ");

    }else{
      let token = this.productoActual.tokenConfig != undefined ? this.productoActual.tokenConfig : this.productoActual.surveyToken;
      let oportunity_id = this.productoActual.oportunity_id != undefined ? this.productoActual.oportunity_id : this.productoActual.oportunity_id;
      this.tokenConfig = token;
      this.oportunity_id = oportunity_id;
      this.datosDetallesProducto.surveyToken = this.tokenConfig;
      this.datosDetallesProducto.oportunity_id = this.oportunity_id;
      localStorage.setItem('surveyToken',token);
      this.getStatusEncuesta(token);
    }
  }

  getStatusEncuesta(token:string){
    let idProducto = this.obtieneTipoProductoCorrecto();
    this.surveyServ.getEstatusCierreEncuesta(token).subscribe((respuesta: any)=>{
      console.log("getEstatusCierreEncuesta:",respuesta);
      this.statusEncuesta = respuesta.result.id_status;
      this.infoEmpresaProducto.next({
        statusEncuesta: this.statusEncuesta
      });
      let statusBotones: boolean;
      if(this.statusEncuesta != 2){
        statusBotones = false;
      } else{
        statusBotones = true;
      }
      //activa o desactiva botones segun el status de encuesta, false = activar y viceversa
      this.setStatusBoton.next({ id: 'primerosColab', status: false});
      this.setStatusBoton.next({ id: 'nuevoColab', status: statusBotones});
      this.setStatusBoton.next({ id: 'buscarColab', status: false});
      this.setStatusBoton.next({ id: 'bajarColab', status: false});
      if(idProducto != 52){   //si no es el producto cgo express muestra el boton
        this.setStatusBoton.next({ id: 'enviaReco', status: statusBotones});
      }
      if(this.productoActual.fechaCertificar != undefined){ //entra si un producto es certificar o 3.0
        this.getFechaLanzamiento(this.anioProducto, idProducto);
      }
    });
  }

  getFechaLanzamiento(datos:any, idProducto:any){
    let data:any = {
      productoId: this.obtieneIdProductoCorrecto()
    };
    this.surveyServ.getFechaLanzamientoStatusEncuesta(this.idEmpresa,data).subscribe((respuesta:any) => {
      console.log("respGetLanza",respuesta);
      if (respuesta.message=="200") {
        this.fechaLanzamientoEncuesta=respuesta.fechaLanzamiento;
        this.setStatusBoton.next({ id: 'verFechIniCie', status: false,visible: true});
        let hoy = moment();
        let fechaLanzamiento = moment(respuesta.fechaLanzamiento);
        if(hoy.isAfter(fechaLanzamiento)){
          if (localStorage.getItem('tipoIdProducto')!='52') {
            this.setStatusBoton.next({ id: 'addPro', status: false});
          }
          this.setStatusBoton.next({ id: 'processRes', status: false});
          this.setStatusBoton.next({ id: 'lockRes', status: false});
          this.setStatusBoton.next({ id: 'verRes', status: false});
          this.setStatusBoton.next({ id: 'upNameIcon', status: false});
          this.setStatusBoton.next({ id: 'regCertifi', status: false});
          this.setStatusBoton.next({ id: 'auditMan', status: false});
          this.setStatusBoton.next({ id: 'libeCultureBrief', status: false});
          this.setStatusBoton.next({ id: 'confirReviCultureAudit', status: false});
          idProducto == 40 ? this.setStatusBoton.next({ id: 'cambiaCultureBrief', status: false,visible: true}) : false;
          this.setStatusBoton.next({ id: 'verWebComPro', status: false,visible: true});
          this.setStatusBoton.next({ id: 'verConfigResult', status: false,visible: true});
          //activa o desactiva los botones de cierre o reapertura de encuesta
          switch (this.statusEncuesta) {
            case 2: //encuesta cerrada
            this.setStatusBoton.next({ id: 'surveyClose', status: true, visible: false});
            this.setStatusBoton.next({ id: 'surveyOpen', status: false, visible: true});
            break;
            default:  //encuesta abierta
            this.setStatusBoton.next({ id: 'surveyClose', status: false, visible: true});
            this.setStatusBoton.next({ id: 'surveyOpen', status: true, visible: false});
          }
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = hoy;
        } else{
          // this.setStatusBoton.next({ id: 'enviaReco', status: true});
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = fechaLanzamiento;
        }
        this.filtroLanzamiento = (d: Date | null): boolean => {
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(respuesta.fechaCierre).format('MM/DD/YYYY')
        };
        this.infoEmpresaProducto.next({
          filtroLanzamiento: this.filtroLanzamiento
        });
        this.setDatosDetalle(null, null, respuesta.fechaLanzamiento, respuesta.fechaCierre, null, null, null);

        this.infoEmpresaProducto.next({
          fechaLanzamiento: respuesta.fechaLanzamiento
        });
        if(this.datosDetallesProducto.fechasProducto[2].activa){  //si hay prorroga activa
          this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[2].fecha); //envia la fecha prorroga
        } else{
          this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[1].fecha); //envia la fecha de cierre
        }
        this.getRecordatorios();
        this.getAvisos();
      }
    });
  }

  getFechaLanzamientoNorma(fechaNorma35:number){
    let dataReg: any = { fechaNorma35 };
    this.surveyServ.getFechaLanzamiento35_req(dataReg, this.idEmpresa).subscribe((respuesta:any) => {
      console.log("getFechaLanzamiento35:",respuesta);
      if (respuesta.message=="200") {

        let hoy = moment();
        let fechaLanzamiento = moment(respuesta.fechaLanzamiento);
        let fechaCierr = moment(respuesta.fechaCierre);
        if(hoy.isAfter(fechaLanzamiento)){
          if (localStorage.getItem('tipoIdProducto')!='52') {
            this.setStatusBoton.next({ id: 'addPro', status: false});
          }
          this.setStatusBoton.next({ id: 'processRes', status: false});
          this.setStatusBoton.next({ id: 'lockRes', status: false});
          // this.setStatusBoton.next({ id: 'verRes', status: false});
          this.setStatusBoton.next({ id: 'upNameIcon', status: false});
          this.setStatusBoton.next({ id: 'regCertifi', status: false});
          this.setStatusBoton.next({ id: 'auditMan', status: false});
          this.setStatusBoton.next({ id: 'libeCultureBrief', status: false});
          this.setStatusBoton.next({ id: 'confirReviCultureAudit', status: false});
          //activa o desactiva los botones de cierre o reapertura de encuesta
          this.setStatusBoton.next({ id: 'surveyClose', status: true, visible: false});
          let disabledBtn= moment(hoy).isBefore(fechaCierr);
          console.log("ya cerro o no :",disabledBtn);
          if (disabledBtn) {
            this.setStatusBoton.next({ id: 'enviaCorreos', status: true});
          }else{
            this.setStatusBoton.next({ id: 'enviaCorreos', status: false});
          }

          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = hoy;
        } else{
          // this.setStatusBoton.next({ id: 'enviaReco', status: true});
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = fechaLanzamiento;
        }
        this.filtroLanzamiento = (d: Date | null): boolean => {
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(respuesta.fechaCierre).format('MM/DD/YYYY')
        };
        this.infoEmpresaProducto.next({
          filtroLanzamiento: this.filtroLanzamiento
        });
        this.setDatosDetalle(this.obtieneTipoProductoCorrecto(), this.anioProducto, respuesta.fechaLanzamiento, respuesta.fechaCierre, null, null, null);
        this.infoEmpresaProducto.next({
          fechaLanzamiento: respuesta.fechaLanzamiento
        });
      }
    }, error => {
      console.log(error);
    });
  }

  getFechaLanzamiento35(){

    let moment = require('moment');
    this.surveyServ.getDateLanNormv2(this.idEmpresa,this.productoActual.idNorma35).subscribe((respuesta:any) => {
      if(respuesta.success ){
        this.datoCargadoNorm=true;
        console.log(respuesta);
        let hoy = moment();
        let fechaLanzamiento = moment(respuesta.programacion.fechaLanzamiento);
        let fechaCierr = moment(respuesta.programacion.fechaCierre);
        if(hoy.isAfter(fechaLanzamiento)){
          if (localStorage.getItem('tipoIdProducto')!='52') {
            this.setStatusBoton.next({ id: 'addPro', status: false});
          }

          this.setStatusBoton.next({ id: 'processRes', status: false});
          this.setStatusBoton.next({ id: 'lockRes', status: false});
          this.setStatusBoton.next({ id: 'verRes', status: false, visible: false});
          this.setStatusBoton.next({ id: 'upNameIcon', status: false});
          this.setStatusBoton.next({ id: 'regCertifi', status: false});
          this.setStatusBoton.next({ id: 'auditMan', status: false});
          this.setStatusBoton.next({ id: 'libeCultureBrief', status: false});
          this.setStatusBoton.next({ id: 'confirReviCultureAudit', status: false});
          //activa o desactiva los botones de cierre o reapertura de encuesta
          this.setStatusBoton.next({ id: 'surveyClose', status: true, visible: false});
          let disabledBtn= moment(hoy).isBefore(fechaCierr);
          console.log("ya cerro o no :",disabledBtn);
          if (disabledBtn) {
            this.setStatusBoton.next({ id: 'enviaCorreos', status: true});
          }else{
            this.setStatusBoton.next({ id: 'enviaCorreos', status: false});
          }

          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = hoy;
        } else{
          // this.setStatusBoton.next({ id: 'enviaReco', status: true});
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = fechaLanzamiento;
        }
        this.filtroLanzamiento = (d: Date | null): boolean => {
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(respuesta.programacion.fechaCierre).format('MM/DD/YYYY')
        };
        this.infoEmpresaProducto.next({
          filtroLanzamiento: this.filtroLanzamiento
        });
        this.infoEmpresaProducto.next({
          fechaLanzamiento: respuesta.programacion.fechaLanzamiento
        });
        this.infoEmpresaProducto.next({
          fechaCierre: respuesta.programacion.fechaCierre
        });
        this.setDatosDetalle(this.obtieneTipoProductoCorrecto(), this.anioProducto, respuesta.programacion.fechaLanzamiento, respuesta.programacion.fechaCierre, null, null, null);
        this.recordatoriosFullInfo = respuesta.programacion.recordatorios;
        this.datosDetallesProducto.recordatorios=respuesta.programacion.recordatorios;
        if (this.recordatoriosFullInfo.length>0) {
          this.mostrarMatRecorda=true;
          this.infoDetalleProducto.emit(this.datosDetallesProducto);
          this.setStatusBoton.next({ id: 'verRecord', status: false});
        }else{
          this.mostrarMatRecorda=false;
          this.setStatusBoton.next({ id: 'verRecord', status: true});
        }
        this.fechasAvisos=respuesta.programacion.recordatoriosN35
        this.datosDetallesProducto.avisos=respuesta.programacion.recordatoriosN35;
        if (this.fechasAvisos.length>0) {
          this.mostrarMatAvisos=true;
          this.infoDetalleProducto.emit(this.datosDetallesProducto);
          this.setStatusBoton.next({ id: 'verAvisos', status: false});
        }else{
          this.mostrarMatAvisos=false;
          this.setStatusBoton.next({ id: 'verAvisos', status: true});
        }

        this.infoEmpresaProducto.next({
          recordatoriosFullInfo: this.recordatoriosFullInfo
        });

        this.infoEmpresaProducto.next({
          fechasAvisos: this.fechasAvisos
        });





      }
    }, error => {
      console.log(error);
    });
  }

  getPorcentajeN35(idProducto:number, param:number){
    this.surveyServ.normaCloseSurvey(idProducto, param, this.idEmpresa).subscribe((respuesta:any) => {
      console.log("param:",param," normaCloseSurvey:",respuesta);
      if(respuesta.success){
        // this.dataTmp2=respuesta.avance;
        // this.porcentaje2=this.dataTmp2.porcentaje;
        let datosActuales: any = {
          actual: respuesta.avance.endUsers,
          total: respuesta.avance.totalUsers,
          porcentaje: (100 / respuesta.avance.totalUsers) * respuesta.avance.endUsers
        };
        let refProgN35 = this.datosDetallesProducto.progresoNom35;
        refProgN35.menos50 = param == 1 ? datosActuales : refProgN35.menos50;
        refProgN35.mas50 = param == 0 ? datosActuales : refProgN35.mas50;
        this.setDatosDetalle(null, null, null, null, null, null, null, refProgN35);
      }
    });
  }

  urlEncuestas(){
    let idProducto = this.obtieneTipoProductoCorrecto();
    console.log('idProducto',idProducto);
 // producto diferente a goflow
 if (idProducto!=70) {
   this.validarEncuesta();
 }

    switch (idProducto) {
      case 1: case 20: case 40: case 41: case 42: case 43: case 56: case 57: case 58: case 68: case 75://casos productos 3.0
      if(this.encuestaCreada == true){
        let datoProducto = {
          productoId: this.productoActual.idCertificar
        };
        this.surveyServ.getPilotoDataEncuesta_estatus(datoProducto,this.idEmpresa).subscribe((data: any) => {
          console.log("getPilotoData:",data);
          if(data.message = 'Success'){
            this.datosDetallesProducto.urlEncuesta = data.piloto.url;
            let esperaEncuestaActiva = setInterval( () => {
              if(this.encuestaActiva != undefined){
                if(this.encuestaActiva == true){
                  this.infoEmpresaProducto.next({
                    urlEncuesta: this.datosDetallesProducto.urlEncuesta
                  });
                  this.setStatusBoton.next({ id: 'goSurvey', status: false, visible: true});
                  var prorrogasAgre = JSON.parse(localStorage.getItem('ProrrogasAgregadas'));
                  // console.log("prorrogasAgre",prorrogasAgre);
                  if (prorrogasAgre != undefined && prorrogasAgre.length>0) {
                    let fechaProrroga=prorrogasAgre[0].fecha;
                    let hoy = moment();
                    let disabledBtn=moment(hoy).isBefore(fechaProrroga);
                    // console.log("bloquedo de btn Fecha Prorroga",disabledBtn);
                    if (disabledBtn) {
                      // console.log("se bloqueo por que ya cerro Fecha Prorroga");
                      this.setStatusBoton.next({ id: 'enviaCorreos', status: true, visible: true});
                    }else{
                      // console.log("se desbloqueo por que aun esta activo Fecha Prorroga");
                      this.setStatusBoton.next({ id: 'enviaCorreos', status: false, visible: true});

                    }

                  }else{
                    let hoy = moment();
                    let disabledBtn=moment(hoy).isBefore(this.datosDetallesProducto.fechasProducto[1].fecha);
                    // console.log("bloquedo de btn Fecha Cierre ",disabledBtn);
                    if (disabledBtn) {
                      // console.log("se bloqueo por que ya cerro Fecha Cierre");

                      this.setStatusBoton.next({ id: 'enviaCorreos', status: true, visible: true});
                    }else{
                      // console.log("se desbloqueo por que aun esta activo Fecha Cierre ");
                      this.setStatusBoton.next({ id: 'enviaCorreos', status: false, visible: true});

                    }

                  }
                }
                clearInterval(esperaEncuestaActiva);
              }
            }, 0);

          }
        });
        let esperaEncuestaActiva = setInterval( () => {
          if(this.encuestaActiva != undefined){
            if(this.encuestaActiva == true){
              this.surveyServ.getAvanceEncuesta(datoProducto,this.idEmpresa).subscribe((respuesta:any) => {
                console.log("getAvanceEncuesta:",respuesta);
                if(respuesta.message == 'Success'){
                  this.setDatosDetalle(this.infoEmpresa.institutoEmpresa == 18 && idProducto == 41 ? 'ICI' : idProducto, this.anioProducto, null, null, null, respuesta.avance.endUsers, respuesta.avance.totalUsers);
                }
              }, error => {
                console.log(error);
              });
            }
            clearInterval(esperaEncuestaActiva);
          }
        }, 0);
      }
      break;
      case 2: case 11: case 12: case 13: case 14: case 15: case 16: //casos productos medir
      let esperaEncuestaActiva = setInterval( () => {
        if(this.encuestaActiva == true){
          this.getUrl_medires();
          this.getAvancesMedir();
          clearInterval(esperaEncuestaActiva);
        }
      }, 0);
      break;
      case 4: //caso producto pulse check v1
      let dataPulse = {productoId: this.productoActual.idPulseCheck};
      this.surveyServ.getPilotoData_Pulse(dataPulse,this.idEmpresa).subscribe((response: any )=> {
        console.log("getPilotoData_Pulse:",response);
        // if(response.message = 'Success'){
        //   this.urlEncuesta=response.data[0].urlShorter;
        //   this.showUrl=true;
        //   this.cierreService.getFechasProgramacionPulse_status(dataPulse,this.idEmpresa).subscribe((respuesta: any)=>{
        //     console.log(respuesta);
        //     this.fechaLanzamiento=respuesta.data[0].fechaLanzamiento;
        //     console.log('this.fechaLanzamiento',this.fechaLanzamiento);
        //
        //     this.fechaCierre=respuesta.data[0].fechaCierre;
        //     let fechaDeCierre=respuesta.data[0].fechaCierre;
        //     let  now = new Date();
        //     console.log("fechaActual",now);
        //     let fechaDeLanzamiento=new Date(this.fechaLanzamiento);
        //     console.log("fechaLanzamientoActual",fechaDeLanzamiento);
        //
        //     if(now>fechaDeLanzamiento){
        //       this.btnProrroga=true;
        //       console.log('btnProrroga',this.btnProrroga);
        //       this.filtroLanzamiento = (d: Date | null): boolean => {
        //         let fechaMinima: any;
        //         return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
        //       };
        //       this.fechaValueProrroga=now;
        //       console.log("fecha actual es mayor a la de lanzamiento");
        //     }else{
        //       this.fechaValueProrroga=fechaDeLanzamiento;
        //       this.bloquearBotonReminder=true;
        //       localStorage.setItem("bloquear_btn","true");
        //       console.log("fecha actual no es mayor a la de lanzamiento");
        //       this.filtroLanzamiento = (d: Date | null): boolean => {
        //         let fechaMinima: any;
        //         return moment(d || new Date()).format('MM/DD/YYYY') > moment(fechaDeCierre).format('MM/DD/YYYY')
        //       };
        //     }
        //     this.disableButton=false;
        //     this.getAvancesPulse();
        //   });
        // }
      }, error => {
        console.log(error);
      });
      break;
      case 52:  //cgo express
      let datoCgoEXP = {
        productoId: this.productoActual._id
      };
      this.surveyServ.getPilotoDataEncuesta_estatus(datoCgoEXP,this.idEmpresa).subscribe((data: any) => {
        console.log("getPilotoData:",data);
        if(data.message = 'Success'){
          this.datosDetallesProducto.urlEncuesta = data.piloto.url
          this.infoEmpresaProducto.next({
            urlEncuesta: this.datosDetallesProducto.urlEncuesta
          });
          this.setStatusBoton.next({ id: 'goSurvey', status: false});

        }
      });
      this.surveyServ.getAvanceEncuesta(datoCgoEXP,this.idEmpresa).subscribe((response:any) => {
        console.log("getAvanceEncuesta:",response);
        if(response.message == 'Success'){
          let hoy = moment();
          let disabledBtn=moment(hoy).isBefore(response.fechaCierre);
          console.log("ya cerro o no :",disabledBtn);
          if (disabledBtn) {
            this.setStatusBoton.next({ id: 'enviaCorreos', status: true});
          }else{
            this.setStatusBoton.next({ id: 'enviaCorreos', status: false});
          }
          let cgoEx = this.productoActual;
          this.setDatosDetalle(cgoEx.idProduct, cgoEx.date, cgoEx.programming.launchDate, cgoEx.programming.closeDate, null, response.avance.endUsers, response.avance.totalUsers);
          let esperaEncuestaActiva = setInterval( () => {
            if(this.encuestaActiva == true){
              setTimeout(() => {
                this.botonesExtraCGOX(cgoEx);
              }, 1000);
              clearInterval(esperaEncuestaActiva);
            }
          }, 0);
        }
      }, error => {
        console.log(error);
      });
      break;

      case 70:
      this.enviaDatosAcciones();
      break;


    }
  }

  botonesExtraCGOX(cgoEx:any){
    let hoy = moment();
    let fechaLanzamiento = moment(cgoEx.programming.launchDate);
    if(hoy.isAfter(fechaLanzamiento)){
      if (localStorage.getItem('tipoIdProducto')!='52') {
        this.setStatusBoton.next({ id: 'addPro', status: false});
      }
      this.setStatusBoton.next({ id: 'processRes', status: false});
      this.setStatusBoton.next({ id: 'lockRes', status: false});
      this.setStatusBoton.next({ id: 'verRes', status: false});
      this.setStatusBoton.next({ id: 'upNameIcon', status: false});
      this.setStatusBoton.next({ id: 'regCertifi', status: false});
      this.setStatusBoton.next({ id: 'auditMan', status: false});
      this.setStatusBoton.next({ id: 'libeCultureBrief', status: false});
      this.setStatusBoton.next({ id: 'confirReviCultureAudit', status: false});
      //activa o desactiva los botones de cierre o reapertura de encuesta
      // switch (this.statusEncuesta) {
      //   case 2: //encuesta cerrada
      //     this.setStatusBoton.next({ id: 'surveyClose', status: true, visible: false});
      //     this.setStatusBoton.next({ id: 'surveyOpen', status: false, visible: true});
      //   break;
      //   default:  //encuesta abierta
      //     this.setStatusBoton.next({ id: 'surveyClose', status: false, visible: true});
      //     this.setStatusBoton.next({ id: 'surveyOpen', status: true, visible: false});
      // }
      this.datosDetallesProducto.fechasProrrogas.valorDatePicker = hoy;
    } else{
      // this.setStatusBoton.next({ id: 'enviaReco', status: true});
      this.datosDetallesProducto.fechasProrrogas.valorDatePicker = fechaLanzamiento;
    }
    this.filtroLanzamiento = (d: Date | null): boolean => {
      return moment(d || new Date()).format('MM/DD/YYYY') > moment(cgoEx.programming.closeDate).format('MM/DD/YYYY')
    };
    this.infoEmpresaProducto.next({
      filtroLanzamiento: this.filtroLanzamiento
    });
    this.infoEmpresaProducto.next({
      fechaLanzamiento: cgoEx.programming.launchDate
    });
    if(this.datosDetallesProducto.fechasProducto[2].activa){  //si hay prorroga activa
      this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[2].fecha); //envia la fecha prorroga
    } else{
      this.bloquearEnvias(moment(),this.datosDetallesProducto.fechasProducto[1].fecha); //envia la fecha de cierre
    }
  }

  validarEncuesta(){
    this.infoSurveyCheck.next([]);
    let token = this.productoActual.tokenConfig != undefined ? this.productoActual.tokenConfig : this.productoActual.surveyToken;
    if(token){
      localStorage.setItem('TokenSurvey',token);
      this.surveyServ.surveyCheck(token).subscribe((respuesta:any) => {
        console.log("surveyCheck:",respuesta);
        if(respuesta.success){
          if(respuesta.result.length == 0){
            this.encuestaActiva = true;
          } else{
            if(respuesta.result[1].value == '0' || respuesta.result[1].value == '-1'){
              this.encuestaActiva = false;
            } else{
              this.encuestaActiva = true;
            }
          }
          console.log("encuestaActiva:",this.encuestaActiva);
          this.cargandoStatusEncuesta = false;
          if(this.encuestaActiva == true){
            setTimeout(() => {
              this.infoSurveyCheck.next(respuesta.result);
              this.setStatusBoton.next({ id: 'surveyCheck', status: false});
              this.setStatusBoton.next({ id: 'surveyDown', status: false});
              this.setStatusBoton.next({ id: 'masterTable', status: false});
              this.enviaDatosAcciones();
            }, 1000);
          }
        }
      }, error => {
        console.log("Survey check services error");
        console.log(error);
      });
    }
  }

  getUrl_medires(){
    let dataMedir = {
      productoId : this.productoActual.idMedir != undefined ? this.productoActual.idMedir : this.productoActual.idProducto
    };
    this.surveyServ.getPilotoData_medir(dataMedir,this.idEmpresa).subscribe( (response: any) => {
      console.log("getPilotoData_medir:",response);
      if(response.message = 'Success'){
        this.datosDetallesProducto.urlEncuesta = response.piloto.url
        this.infoEmpresaProducto.next({
          urlEncuesta: this.datosDetallesProducto.urlEncuesta
        });
        this.setStatusBoton.next({ id: 'goSurvey', status: false});
      }
    });
  }

  getAvancesMedir(){
    let data={
      productoId: this.productoActual.idMedir != undefined ? this.productoActual.idMedir : this.productoActual.idProducto
    };
    this.surveyServ.getAvanceEncuestaMedir(data,this.idEmpresa).subscribe((respuesta:any) => {
      console.log("getAvanceEncuestaMedir:",respuesta);
      if (respuesta.message=="Success") {
        let hoy = moment();
        let fechaLanzamiento = moment(respuesta.fechaLanzamiento);
        if(hoy.isAfter(fechaLanzamiento)){
          if (localStorage.getItem('tipoIdProducto')!='52') {
            this.setStatusBoton.next({ id: 'addPro', status: false});
          }
          this.setStatusBoton.next({ id: 'processRes', status: false});
          this.setStatusBoton.next({ id: 'lockRes', status: false});
          this.setStatusBoton.next({ id: 'verRes', status: false});
          this.setStatusBoton.next({ id: 'upNameIcon', status: false});
          this.setStatusBoton.next({ id: 'regCertifi', status: false});
          this.setStatusBoton.next({ id: 'auditMan', status: false});
          this.setStatusBoton.next({ id: 'libeCultureBrief', status: false});
          this.setStatusBoton.next({ id: 'confirReviCultureAudit', status: false});
          //activa o desactiva los botones de cierre o reapertura de encuesta
          switch (this.statusEncuesta) {
            case 2: //encuesta cerrada
            this.setStatusBoton.next({ id: 'surveyClose', status: true, visible: false});
            this.setStatusBoton.next({ id: 'surveyOpen', status: false, visible: true});
            break;
            default:  //encuesta abierta
            this.setStatusBoton.next({ id: 'surveyClose', status: false, visible: true});
            this.setStatusBoton.next({ id: 'surveyOpen', status: true, visible: false});
          }
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = hoy;
        } else{
          // this.setStatusBoton.next({ id: 'enviaReco', status: true});
          this.datosDetallesProducto.fechasProrrogas.valorDatePicker = fechaLanzamiento;
        }
        this.filtroLanzamiento = (d: Date | null): boolean => {
          return moment(d || new Date()).format('MM/DD/YYYY') > moment(respuesta.fechaCierre).format('MM/DD/YYYY')
        };
        this.infoEmpresaProducto.next({
          filtroLanzamiento: this.filtroLanzamiento
        });
        this.setDatosDetalle(this.obtieneTipoProductoCorrecto(), this.anioProducto, respuesta.fechaLanzamiento, respuesta.fechaCierre, null, respuesta.avance.endUsers, respuesta.avance.totalUsers);
        this.infoEmpresaProducto.next({
          fechaLanzamiento: respuesta.fechaLanzamiento
        });

        let disabledBtn= moment(hoy).isBefore(respuesta.fechaCierre);
        console.log("ya cerro o no :",disabledBtn);
        if (disabledBtn) {
          this.setStatusBoton.next({ id: 'enviaCorreos', status: true});
        }else{
          this.setStatusBoton.next({ id: 'enviaCorreos', status: false});
        }
      }
    }, error => {
      console.log("Estatus cierre encuesta");
      console.log(error);
    });
  }


  verResultadosIframe(datos:any){
    console.log('datos',datos);
    this.mostrarIframe.emit(datos);
  }

  actualizarRecordatorios(status:boolean){
    console.log("actualiza recordatorios despues de actualizar 1 ");
    let idProducto = this.obtieneTipoProductoCorrecto();
    if (status) {
      console.log("si lo actualizo ");
      if (idProducto==63) {
        this.getFechaLanzamiento35();
      }else{
        this.getRecordatorios();
      }
    }

  }
  actualizarFechIniCie(status:boolean){
    console.log("actualiza fecha inicio o cierre",status);

    if (status) {
      console.log("si lo actualizo ");
      let idProducto = this.obtieneTipoProductoCorrecto();
      this.getFechaLanzamiento(this.anioProducto, idProducto);
    }

  }
  actualizarAvisos(status:boolean){
    console.log("actualiza avisos despues de actualizar 1 ");
    let idProducto = this.obtieneTipoProductoCorrecto();
    if (status) {
      console.log("si lo actualizo ");
      if (idProducto==63) {
        this.getFechaLanzamiento35();
      }else{
        this.getAvisos();
      }

    }

  }

  private getPilotoDataNorma35(idProducto){
    console.log('idProducto',idProducto);

    let dataEnc={
      productoId: this.productoActual.idNorma35
    };

    this.surveyServ.obtenerPilito(this.idEmpresa,dataEnc)
    .subscribe((response:backInter.getPilotoN35) => {
      console.log(response);
      if(response.success){
        if(response.urlMas50.length > 1){
          console.log("urlMás");
          this.urlNormaMas50= response.urlMas50
        }

        if(response.urlMenos50.length>1){
          console.log("urlMenos50");
          this.urlNormaMenos50= response.urlMenos50
        }

        setTimeout(() => {
          if (idProducto==63) {
            this.enviaDatosAccionesNorV3();
          }else if(idProducto==3){
            this.enviaDatosAcciones();
          }
        }, 1000);
      }
    }, error => {
      console.log(error);
    });


  }

  getRecordatorios(){
    console.log('productoActual',this.productoActual);

    let data: any = {
      productoId: localStorage.getItem('productoID')
    };
    this.sheduleService.getRecordatorios(data).subscribe((respuesta:any) => {
      console.log("respGetReco",respuesta);
      if(respuesta.message == '200'){
        this.recordatoriosFullInfo = respuesta.recordatoriosMostrar;
        this.datosDetallesProducto.recordatorios=respuesta.recordatoriosMostrar;
        if (this.recordatoriosFullInfo.length>0) {
          this.mostrarMatRecorda=true;
          this.infoDetalleProducto.emit(this.datosDetallesProducto);
          this.setStatusBoton.next({ id: 'verRecord', status: false});
        }else{
          this.mostrarMatRecorda=false;
          this.setStatusBoton.next({ id: 'verRecord', status: true});
        }
        this.infoEmpresaProducto.next({
          recordatoriosFullInfo: this.recordatoriosFullInfo
        });
        // respuesta.recordatoriosMostrar.forEach(recordatorio => {
        //   this.fechasRecordatorios.push( recordatorio.fechaRecordatorio );
        // });
        console.log("fechasREcos:",this.recordatoriosFullInfo);

      }
    }, error => {
      console.log(error);
    });
  }

  getAvisos(){
    console.log('productoActual',this.productoActual);

    this.encuestaService.getAviso().subscribe((respuesta:any) => {
      console.log("getAviso:",respuesta);
      if(respuesta.success){
        let arregloAviso:any[]=[];
        if(respuesta.aviso1){
          let aviso1={
            aviso:respuesta.aviso1,
            num:1}
            arregloAviso.push(aviso1)
          }
          if(respuesta.aviso2){
            let aviso2={
              aviso:respuesta.aviso2,
              num:2}
              arregloAviso.push(aviso2)
            }
            this.fechasAvisos=arregloAviso

            this.datosDetallesProducto.avisos=this.fechasAvisos;
            if (this.fechasAvisos.length>0) {
              this.mostrarMatAvisos=true;
              this.infoDetalleProducto.emit(this.datosDetallesProducto);
              this.setStatusBoton.next({ id: 'verAvisos', status: false});
            }else{
              this.mostrarMatAvisos=false;
              this.setStatusBoton.next({ id: 'verAvisos', status: true});
            }
            this.infoEmpresaProducto.next({
              fechasAvisos: this.fechasAvisos
            });
            // respuesta.recordatoriosMostrar.forEach(recordatorio => {
            //   this.fechasRecordatorios.push( recordatorio.fechaRecordatorio );
            // });
            console.log("fechasREcos:",this.fechasAvisos);








          }
        });
      }

      indiceTab(indexTab:any){
        console.log(indexTab);
        if (indexTab.index==2) {
          this.consultarEmailLog.next(true);
        }

      }
    }
